import { useEffect } from "react";

const BASE = "https://luxelords.co.uk";

function setMeta(attr: "name" | "property", key: string, value: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.content = value;
}

/** Sets per-page title, description, canonical and og tags. */
export function useSeo(title: string | undefined, description: string | undefined, path: string) {
  useEffect(() => {
    if (!title) return;
    const url = `${BASE}${path}`;
    document.title = title;
    setMeta("property", "og:title", title);
    setMeta("property", "og:url", url);
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;
  }, [title, description, path]);
}
